import { useEffect } from "react";
import { isEditingText } from "../schedule-history/use-history-shortcuts";
import { getCanvasState, getCanvasMetadataTargets } from "../schedule-art/canvas-state";
import { useMetadataEditingStore } from "../../stores/metadata-editing-store";
import { dispatchMetadataEvent } from "./dispatch";
import { rotateLayoutOffset } from "../schedule-art/layout-coordinates";

const arrowSteps: Record<string, number[]> = {
  ArrowLeft: [-1, 0],
  ArrowRight: [1, 0],
  ArrowUp: [0, -1],
  ArrowDown: [0, 1],
};

function nudgeSelected(direction: number[], distance: number) {
  const selected = useMetadataEditingStore.getState().selected;
  const target = getCanvasMetadataTargets().find(target => target.path === selected);
  if (!target) return;
  const canvasDelta = direction.map(value => value * distance);
  const localDelta = rotateLayoutOffset(canvasDelta, -(target.layoutRotation ?? 0));
  const point = target.point.map((value, axis) => Math.round(value + localDelta[axis]!));
  dispatchMetadataEvent({ type: "position/set", path: target.path, point }, `${target.path}:nudge`);
}

export function useMetadataNudgeShortcuts() {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      const { developerMode } = getCanvasState();
      const { selected, select } = useMetadataEditingStore.getState();
      const hasSelection = developerMode && !!selected;
      if (!hasSelection) return;
      if (isEditingText(event.target)) return;
      if (event.key === "Escape") {
        select(null);
        return;
      }
      const direction = arrowSteps[event.key];
      if (!direction) return;
      event.preventDefault();
      const distance = event.shiftKey ? 10 : 1;
      nudgeSelected(direction, distance);
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);
}
